import { render, staticRenderFns } from "./MyBusinessFooter.vue?vue&type=template&id=e5300712"
import script from "./MyBusinessFooter.vue?vue&type=script&lang=js"
export * from "./MyBusinessFooter.vue?vue&type=script&lang=js"
import style0 from "./MyBusinessFooter.vue?vue&type=style&index=0&id=e5300712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports